import { type MultiButtonOptionType } from '../../../buttons/MultiButton';
import { type DetailsButtonProps } from '../DetailsPage';
import { showDeleteDialog } from '../../../dialogs/DeleteDialog';

const buttons: MultiButtonOptionType<DetailsButtonProps>[] = [
	{
		name: 'VIEW_ITEM_BUTTON_RESTORE',
		icon: 'backup-restore',
		action: ({ settings, model, dispatch }) =>
			dispatch(
				showDeleteDialog({
					module: settings.modu_title,
					id: model[`${settings.modu_short}_uid`] || model[`${settings.modu_short}_id`],
					title: model[`${settings.modu_short}_title`],
					restore: true
				})
			)
	},
	{
		name: 'VIEW_ITEM_BUTTON_PERMANENT_DELETE',
		icon: 'delete',
		action: ({ settings, model, dispatch }) =>
			dispatch(
				showDeleteDialog({
					module: settings.modu_title,
					id: model[`${settings.modu_short}_uid`] || model[`${settings.modu_short}_id`],
					title: model[`${settings.modu_short}_title`],
					hardDelete: true
				})
			)
	}
];

export default buttons;
